document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('[data-wfy-section]');

  sections.forEach(function (section) {
    var slider = section.querySelector('[data-wfy-slider]');
    if (!slider) return;

    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-wfy-slide]'));
    if (slides.length === 0) return;

    var prevBtn = section.querySelector('[data-wfy-prev]');
    var nextBtn = section.querySelector('[data-wfy-next]');
    var currentEl = section.querySelector('[data-wfy-current]');
    var stars = section.querySelectorAll('[data-wfy-star]');

    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var autoplaySpeed = parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5000;
    var currentIndex = 0;
    var timer = null;

    function showSlide(index) {
  if (index < 0 || index >= slides.length) return;

  slides.forEach(function (slide, i) {
    slide.classList.toggle('is-active', i === index);
  });

  if (currentEl) {
    currentEl.textContent = index + 1;
  }

  var rating = parseInt(
    slides[index].getAttribute('data-rating'),
    10
  );

  // If rating is missing/invalid, default to 5.
  // But keep 0 as 0.
  if (isNaN(rating)) {
    rating = 5;
  }

  /*
   * Update stars
   */
  var starsContainer = section.querySelector('[data-wfy-stars]');
  var stars = section.querySelectorAll('[data-wfy-star]');

  if (starsContainer) {
    if (rating === 0) {
      starsContainer.style.display = 'none';
    } else {
      starsContainer.style.display = '';

      stars.forEach(function (star, i) {
        star.classList.toggle('is-filled', i < rating);
      });
    }
  }

  currentIndex = index;

  /*
   * Update arrow states
   */
  if (prevBtn && nextBtn) {

    prevBtn.disabled = false;
    nextBtn.disabled = false;

    prevBtn.classList.remove('is-disabled');
    nextBtn.classList.remove('is-disabled');

    prevBtn.style.cursor = 'pointer';
    nextBtn.style.cursor = 'pointer';

    prevBtn.style.color = '#5C5757';
    nextBtn.style.color = '#5C5757';

    /*
     * First slide
     */
    if (currentIndex === 0) {

      prevBtn.disabled = true;
      prevBtn.classList.add('is-disabled');

      prevBtn.style.color = '#6E6969';
      prevBtn.style.cursor = 'not-allowed';

      nextBtn.style.color = '#5C5757';
      nextBtn.style.cursor = 'pointer';

    }

    /*
     * Last slide
     */
    else if (currentIndex === slides.length - 1) {

      nextBtn.disabled = true;
      nextBtn.classList.add('is-disabled');

      prevBtn.style.color = '#5C5757';
      prevBtn.style.cursor = 'pointer';

      nextBtn.style.color = '#6E6969';
      nextBtn.style.cursor = 'not-allowed';

    }

    /*
     * Middle slides
     */
    else {

      prevBtn.style.color = '#5C5757';
      nextBtn.style.color = '#5C5757';

    }
  }
}

    function goNext() {
      showSlide(currentIndex + 1);
    }

    function goPrev() {
      showSlide(currentIndex - 1);
    }

    function startAutoplay() {
      if (!autoplay || slides.length < 2) return;
      stopAutoplay();
      timer = setInterval(goNext, autoplaySpeed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goNext();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goPrev();
        startAutoplay();
      });
    }

    // Pause autoplay while the user hovers or focuses the slider
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('focusin', stopAutoplay);
    slider.addEventListener('focusout', startAutoplay);

    showSlide(0);
    startAutoplay();
  });
});